// Reads the current captcha token regardless of which provider rendered the widget.
// Turnstile injects an input named `cf-turnstile-response`; reCAPTCHA v2 uses the
// `g-recaptcha-response` element. Returns '' when neither widget has produced a token yet,
// so callers can keep treating a non-empty string as "solved".
export default function captchaResponse() {
  const turnstile = document.querySelector('[name="cf-turnstile-response"]')
  if (turnstile) return turnstile.value || ''

  const recaptcha = document.getElementById('g-recaptcha-response')
  return recaptcha ? recaptcha.value || '' : ''
}

// The per-form captcha callbacks live in inline <script> blocks in the view partials, which
// cannot import modules, so expose it globally as well.
window.captchaResponse = captchaResponse

// A captcha callback runs exactly once, when the widget resolves, and the forms that gate their
// submit button on BOTH a token and an agreement checkbox read that checkbox at that moment.
//
// reCAPTCHA v2 hid the problem: it was a checkbox the customer clicked, and they clicked it after
// ticking the agreement, so the one call saw a complete form. Turnstile in managed mode resolves
// by itself on page load, before the customer has ticked anything -- so the single call finds the
// agreement unchecked and is never invoked again. A refresh makes it worse, because it guarantees
// the captcha wins the race.
//
// Re-run whichever captchaSubmit the page defined whenever a checkbox changes, so the gate is
// evaluated again by whichever half finishes last.
const reevaluateCaptchaGate = (event) => {
  const target = event.target

  if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return
  if (typeof window.captchaSubmit !== 'function') return

  window.captchaSubmit()
}

// Both phases, deliberately.
//
// The agreement checkboxes are readonly and are ticked programmatically from their modals, which
// dispatch `new Event('change')` -- and that defaults to bubbles: false, so a listener registered
// on document for the bubble phase alone never sees it. The capture phase still runs for a
// non-bubbling event, so it is the only one that catches the modal path.
//
// The bubble registration is kept because capture runs before the form's own handlers: for a real
// click, this guarantees one more evaluation after everything else has had its say. captchaSubmit
// is idempotent, so being called twice is free.
document.addEventListener('change', reevaluateCaptchaGate, true)
document.addEventListener('change', reevaluateCaptchaGate)
